const ROLE_BADGE = {
  PRIMARY: "bg-emerald-100 text-emerald-800",
  DEDUCTION: "bg-yellow-100 text-yellow-800",
};

export default function DerivationResponse({ data }) {
  if (!data) return null;
  const { formula, groups = [] } = data;

  return (
    <div className="mt-2 w-full flex flex-col gap-2">
      {/* Formula bar */}
      {formula?.expression && (
        <div className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 font-mono text-[12px] text-gray-500">
          〈 {formula.expression} 〉
        </div>
      )}

      {/* Groups */}
      {groups.map((g, i) => {
        const name = g.title || g.source;
        const badgeClass = ROLE_BADGE[g.role] || "bg-gray-100 text-gray-600";
        return (
          <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden">
            {/* Header */}
            <div className="flex items-center gap-2 px-4 py-2.5 border-b border-gray-100">
              <span className="font-mono text-[13px] font-medium text-gray-800">{name}</span>
              <span className={`text-[11px] font-medium px-2 py-0.5 rounded ${badgeClass}`}>
                {g.role}
              </span>
            </div>

            {/* Fields */}
            {g.fields?.map((f, j) => (
              <div key={j} className="flex items-center px-4 py-2.5 border-b border-gray-100 last:border-b-0">
                <span className="font-mono text-[12px] text-blue-600 w-44 min-w-[120px]">
                  {f.label}
                </span>
                <span className="text-[12px] text-gray-500">{f.description}</span>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}